export default __webpack_public_path__ + "static/whyUs-b608b7d4a43b38ad430fdfe712a6a4b0.png";